import { IFormSchemaSection } from "../types";
import { isHiddenUiField } from "../utils/fieldRules";
import { isPrefilledReadOnlyField } from "../utils/isSharedPiiField";
import { selectorVisibleFields } from "./selectorVisibleFields";

export interface IIdentitySectionSplit {
  /**
   * Read-only identity sections — every rendered field is server-prefilled and
   * non-editable (e.g. the "Your information" worker/employer block). These are
   * merged into the single identity card on the wizard's first page.
   */
  identitySections: IFormSchemaSection[];
  /** Everything else — the editable form sections the wizard steps through. */
  formSections: IFormSchemaSection[];
}

// The section's fields that actually render something (visible and not a
// Hidden-UI worksheet intermediate).
const renderedFields = (section: IFormSchemaSection) =>
  selectorVisibleFields(section.fields).filter(
    field => !isHiddenUiField(field)
  );

/**
 * Splits a form's sections into read-only IDENTITY sections and the remaining
 * form sections. A section is an identity section when it renders at least one
 * field and every rendered field is pre-filled read-only data (stamped
 * server-side from previously collected forms / live records). Order is
 * preserved within both halves.
 */
export const selectorIdentitySectionSplit = (
  sections: IFormSchemaSection[]
): IIdentitySectionSplit => {
  const identitySections: IFormSchemaSection[] = [];
  const formSections: IFormSchemaSection[] = [];

  sections.forEach(section => {
    const rendered = renderedFields(section);
    const isIdentity =
      rendered.length > 0 && rendered.every(isPrefilledReadOnlyField);
    (isIdentity ? identitySections : formSections).push(section);
  });

  return { identitySections, formSections };
};
